<template>
  <div class="container">
    <YuanHengLabelDialog
      factoryName="元亨"
      :visible.sync="yuanHengLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <QiangLiJuCaiLabelDialog
      factoryName="强力巨彩"
      :visible.sync="qiangLiJuCaiLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <QiangLiJuCaiLabelV2Dialog
      factoryName="强力巨彩V2"
      :visible.sync="qiangLiJuCaiLabelV2DialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <LiYaDeLabelDialog
      factoryName="利亚德"
      :visible.sync="liYaDeLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <YiShiDaLabelDialog
      factoryName="易事达"
      :visible.sync="yiShiDaLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <BaKeLabelDialog
      factoryName="巴科"
      labelName="baKe"
      :visible.sync="baKeLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <LeiManLabelDialog
      factoryName="惠州雷曼"
      labelName="leiMan"
      :visible.sync="leiManLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <MeiKaLeLabelDialog
      factoryName="美卡乐"
      labelName="baKe"
      :visible.sync="meiKaLeLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <JianHeLabelDialog
      factoryName="惠州健和"
      :visible.sync="JianHeLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <JinLiXiangLabelDialog
      factoryName="金立翔"
      :visible.sync="jinLiXiangLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <ShiXinLabelDialog
      factoryName="视芯(重打)"
      :visible.sync="shiXinLabelDialogDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <QiangLiBoxLabelDialog
      factoryName="强力外箱加贴"
      :visible.sync="qiangLiBoxLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <LianJianLabelDialog
      factoryName="惠州联建"
      :visible.sync="lianJianLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <WaferLabelDialog
      factoryName="晶圆袋"
      :visible.sync="waferLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <BoxLabelDialog
      factoryName="晶圆角"
      :visible.sync="boxLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <WaferBoxLabelDialog
      factoryName="晶圆箱"
      :visible.sync="waferBoxLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <BagLabelDialog
      factoryName="袋上的标签/B袋"
      :visible.sync="bagLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <MembraneLabelLabelDialog 
      factoryName="蓝膜上的"
      :visible.sync="membraneLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <CaseLabelDialog
      factoryName="箱上的"
      :visible.sync="caseLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <BagLabelCDialog
      factoryName="袋上的标签/C袋"
      :visible.sync="bagLabelCDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <ModuleNoLabelDialog 
      factoryName="模块编号"
      :visible.sync="moduleNoDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <ShiXinLabelV2Dialog 
      factoryName="视芯标签升级"
      :visible.sync="shiXinLabelV2DialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <HuaLanLabelDialog
      factoryName="花蓝"
      :visible.sync="huaLanLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"
    />
    <JingTaiLabelDialog 
      factoryName="晶台标签"
      :visible.sync="jingTaiLabelDialogVisible"
      :editRow="editRow"
      :isBoxLabel="isBoxLabel"
      @update="getLabelData"    
    />
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.labelType') + ':'" prop="labelType">
        <el-select
          v-model="form.label"
          filterable
          size="small">
          <el-option
            v-for="item in labelList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.labelName') + ':'" prop="labelType">
        <el-select
          filterable
          v-model="form.labelType"
          size="small"
          @change="query">
          <el-option
            v-for="item in labelTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" v-if="keywordVal" :label="keywordVal + ':'" prop="keyword">
        <el-input
          v-model.trim="form.keyword"
          name="trackingNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="query">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="target-container">
      <el-table
        v-loading="loading"
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column key="processingOrderNo_YH" v-if="isLabelTypeYuanHeng" prop="processingOrderNo" label="加工单号"></el-table-column>
        <el-table-column key="purchaseOrderNo_YH" v-if="isLabelTypeYuanHeng" prop="purchaseOrderNo" label="采购单号"></el-table-column>
        <el-table-column key="customPartNo_YH" v-if="isLabelTypeYuanHeng" prop="customPartNo" label="物料编号"></el-table-column>
        <el-table-column key="partNo_YH" v-if="isLabelTypeYuanHeng" prop="partNo" label="规格型号"></el-table-column>
        <el-table-column key="dateCode_YH" v-if="isLabelTypeYuanHeng" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="trackingNo_YH" v-if="isLabelTypeYuanHeng" prop="trackingNo" label="批次号"></el-table-column>
        <el-table-column key="qty_YH" v-if="isLabelTypeYuanHeng" prop="qty" label="数量"></el-table-column>
        <el-table-column key="reserve_YH" v-if="isLabelTypeYuanHeng" prop="reserve" label="外箱箱号"></el-table-column>

        <el-table-column key="partNo_QL" v-if="isLabelTypeQiangli" prop="partNo" label="品名/规格"></el-table-column>
        <el-table-column key="customPartNo_YH" v-if="isLabelTypeQiangli" prop="customPartNo" label="物料编码"></el-table-column>
        <el-table-column key="purchaseOrderNo_YH" v-if="isLabelTypeQiangli" prop="purchaseOrderNo" label="订单号"></el-table-column>
        <el-table-column key="qty_YH" v-if="isLabelTypeQiangli" prop="qty" label="数量"></el-table-column>
        <el-table-column key="grossWeight_YH" v-if="isLabelTypeQiangli" prop="grossWeight" label="重量(kg)"></el-table-column>
        <el-table-column key="dateCode_YH" v-if="isLabelTypeQiangli" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="trackingNo_YH" v-if="isLabelTypeQiangli" prop="trackingNo" label="强力批号"></el-table-column>

        <el-table-column key="IC_QLV2" v-if="isLabelTypeQiangliV2" label="物料名称" prop="processingOrderNo"></el-table-column>
        <el-table-column key="partNo_QLV2" v-if="isLabelTypeQiangliV2" prop="partNo" label="规格型号"></el-table-column>
        <el-table-column key="customPartNo_QLV2" v-if="isLabelTypeQiangliV2" prop="customPartNo" label="物料编号"></el-table-column>
        <el-table-column key="qty_QLV2" v-if="isLabelTypeQiangliV2" prop="qty" label="数量"></el-table-column>
        <el-table-column key="trackingNo_QLV2" v-if="isLabelTypeQiangliV2" prop="trackingNo" label="批号/档次"></el-table-column>
        <el-table-column key="dateCode_QLV2" v-if="isLabelTypeQiangliV2" prop="dateCode" label="生产日期"></el-table-column>
        <el-table-column key="IC56_QLV2" v-if="isLabelTypeQiangliV2" label="供应商代码">IC56</el-table-column>

        <el-table-column key="customPartNo_QLBox" v-if="isLabelTypeQiangliBox" prop="customPartNo" label="箱号"></el-table-column>
        <el-table-column key="partNo_QLBox" v-if="isLabelTypeQiangliBox" prop="partNo" label="规格型号"></el-table-column>
        <el-table-column key="trackingNo_QLBox" v-if="isLabelTypeQiangliBox" prop="trackingNo" label="批号/档次"></el-table-column>
        <el-table-column key="lotNo_QLBox" v-if="isLabelTypeQiangliBox" prop="lotNo" label="外箱批号"></el-table-column>

        <el-table-column key="purchaseOrderNo_LYD" v-if="isLabelTypeLiYaDe" prop="purchaseOrderNo" label="订单编号"></el-table-column>
        <el-table-column key="customPartNo_LYD" v-if="isLabelTypeLiYaDe" prop="customPartNo" label="LYD物料编码"></el-table-column>
        <el-table-column key="partNo_LYD" v-if="isLabelTypeLiYaDe" prop="partNo" label="LYD物料描述"></el-table-column>
        <el-table-column key="qty_LYD" v-if="isLabelTypeLiYaDe" prop="qty" label="数量"></el-table-column>
        <el-table-column key="dateCode_LYD" v-if="isLabelTypeLiYaDe" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="lotNo_LYD" v-if="isLabelTypeLiYaDe" prop="lotNo" label="生产批次"></el-table-column>

        <el-table-column key="partNo_common" v-if="isLabelTypeCommon" prop="partNo" label="PARTNO"></el-table-column>
        <el-table-column key="lotNo_common" v-if="isLabelTypeCommon" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_common" v-if="isLabelTypeCommon" prop="qty" label="数量"></el-table-column>
        <el-table-column key="trackingNo_common" v-if="isLabelTypeCommon" prop="trackingNo" label="Tracking No"></el-table-column>
        <el-table-column key="dateCode_common" v-if="isLabelTypeCommon" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="packageType_common" v-if="isLabelTypeCommon" prop="packageType" label="封装形式"></el-table-column>
        <el-table-column key="marking_common" v-if="isLabelTypeCommon" prop="marking" label="Marking"></el-table-column>
        <el-table-column key="grossWeight_common" v-if="isLabelTypeCommon" prop="grossWeight" label="毛重(kg)"></el-table-column>
        <el-table-column key="netWeight_common" v-if="isLabelTypeCommon" prop="netWeight" label="净重(kg)"></el-table-column>
        <el-table-column key="customPartNo_common" v-if="isLabelTypeCommon" prop="customPartNo" label="客户料号"></el-table-column>
        <el-table-column key="reserve_common" v-if="isLabelTypeCommon" prop="reserve" label="档位">
          <template slot-scope="scope">
            {{scope.row.reserve === null ? 'A' : scope.row.reserve}}
          </template>
        </el-table-column>

        <el-table-column key="purchaseOrderNo_YSD" v-if="isLabelTypeYiShiDa" prop="purchaseOrderNo" label="订单号"></el-table-column>
        <el-table-column key="customPartNo_YSD" v-if="isLabelTypeYiShiDa" prop="customPartNo" label="客户料号"></el-table-column>
        <el-table-column key="qty_YSD" v-if="isLabelTypeYiShiDa" prop="qty" label="数量"></el-table-column>

        <el-table-column key="customPartNo_JH" v-if="isLabelTypeJianHe" prop="customPartNo" label="物料编码"></el-table-column>
        <el-table-column key="partNo_JH" v-if="isLabelTypeJianHe" prop="partNo" label="物料名称"></el-table-column>
        <el-table-column key="purchaseOrderNo_JH" v-if="isLabelTypeJianHe" prop="purchaseOrderNo" label="合同号"></el-table-column>
        <el-table-column key="dateCode_JH" v-if="isLabelTypeJianHe" prop="dateCode" label="送货日期"></el-table-column>

        <el-table-column key="purchaseOrderNo_JLX" v-if="isLabelTypeJinLiXiang" prop="purchaseOrderNo" label="订单编号"></el-table-column>
        <el-table-column key="customPartNo_JLX" v-if="isLabelTypeJinLiXiang" prop="customPartNo" label="物料编码"></el-table-column>
        <el-table-column key="partNo_JLX" v-if="isLabelTypeJinLiXiang" prop="partNo" label="物料描述"></el-table-column>
        <el-table-column key="qty_JLX" v-if="isLabelTypeJinLiXiang" prop="qty" label="数量"></el-table-column>
        <el-table-column key="dateCode_JLX" v-if="isLabelTypeJinLiXiang" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="lotNo_JLX" v-if="isLabelTypeJinLiXiang" prop="lotNo" label="生产批次"></el-table-column>

        <el-table-column key="partNo_SX" v-if="isLabelTypeShiXin" prop="partNo" label="PARTNO"></el-table-column>
        <el-table-column key="lotNo_SX" v-if="isLabelTypeShiXin" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_SX" v-if="isLabelTypeShiXin" prop="qty" label="数量"></el-table-column>
        <el-table-column key="trackingNo_SX" v-if="isLabelTypeShiXin" prop="trackingNo" label="Tracking No"></el-table-column>
        <el-table-column key="binLevel_SX" v-if="isLabelTypeShiXin" prop="binLevel" label="档位"></el-table-column>
        <el-table-column key="dateCode_SX" v-if="isLabelTypeShiXin" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="packageType_SX" v-if="isLabelTypeShiXin" prop="packageType" label="封装形式"></el-table-column>
        <el-table-column key="marking_SX" v-if="isLabelTypeShiXin" prop="marking" label="Marking"></el-table-column>
        <el-table-column key="grossWeight_SX" v-if="isLabelTypeShiXin && isBoxLabel" prop="grossWeight" label="毛重(kg)"></el-table-column>
        <el-table-column key="netWeight_SX" v-if="isLabelTypeShiXin && isBoxLabel" prop="netWeight" label="净重(kg)"></el-table-column>

        <el-table-column key="customPartNo_LJ" v-if="isLabelTypeLianJian" prop="customPartNo" label="物料编码"></el-table-column>
        <el-table-column key="partNo_LJ" v-if="isLabelTypeLianJian" prop="partNo" label="物料名称"></el-table-column>
        <el-table-column key="purchaseOrderNo_LJ" v-if="isLabelTypeLianJian" prop="purchaseOrderNo" label="合同号"></el-table-column>
        <el-table-column key="dateCode_LJ" v-if="isLabelTypeLianJian" prop="dateCode" label="送货日期"></el-table-column>

        <el-table-column key="partNo_JYD" v-if="isLabelTypeJingYuanDai" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_JYD" v-if="isLabelTypeJingYuanDai" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="trackingNo_JYD" v-if="isLabelTypeJingYuanDai" prop="trackingNo" label="Tracking No"></el-table-column>
        <el-table-column key="qty_JYD" v-if="isLabelTypeJingYuanDai" prop="qty" label="片数"></el-table-column>
        <el-table-column key="customPartNo_JYD" v-if="isLabelTypeJingYuanDai" prop="customPartNo" label="片号"></el-table-column>
        <el-table-column key="marking_JYD" v-if="isLabelTypeJingYuanDai" prop="marking" label="prop"></el-table-column>
        <el-table-column key="dateCode_JYD" v-if="isLabelTypeJingYuanDai" prop="dateCode" label="入库时间"></el-table-column>
        <el-table-column key="reserve_JYD" v-if="isLabelTypeJingYuanDai" prop="reserve" label="数量"></el-table-column>
        <el-table-column key="binLevel_JYD" v-if="isLabelTypeJingYuanDai" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_JYP" v-if="isLabelTypeJingYuanPian" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_JYP" v-if="isLabelTypeJingYuanPian" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="marking_JYP" v-if="isLabelTypeJingYuanDai" prop="marking" label="片号"></el-table-column>
        <el-table-column key="reserve_JYP" v-if="isLabelTypeJingYuanPian" prop="reserve" label="数量"></el-table-column>
        <el-table-column key="binLevel_JYP" v-if="isLabelTypeJingYuanPian" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_JYB" v-if="isLabelTypeJingYuanBox" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_JYB" v-if="isLabelTypeJingYuanBox" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_JYB" v-if="isLabelTypeJingYuanBox" prop="qty" label="片数"></el-table-column>
        <el-table-column key="trackingNo_JYB" v-if="isLabelTypeJingYuanBox" prop="trackingNo" label="Tracking No"></el-table-column>
        <el-table-column key="dateCode_JYB" v-if="isLabelTypeJingYuanBox" prop="dateCode" label="入库时间"></el-table-column>
        <el-table-column key="reserve_JYB" v-if="isLabelTypeJingYuanBox" prop="reserve" label="数量"></el-table-column>
        <el-table-column key="binLevel_JYB" v-if="isLabelTypeJingYuanBox" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_BAG" v-if="isLabelTypeBag" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_BAG" v-if="isLabelTypeBag" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_BAG" v-if="isLabelTypeBag" prop="qty" label="QTY"></el-table-column>
        <el-table-column key="dateCode_BAG" v-if="isLabelTypeBag" prop="dateCode" label="Date"></el-table-column>
        <el-table-column key="customPartNo_BAG" v-if="isLabelTypeBag" prop="customPartNo" label="WFR NO"></el-table-column>
        <el-table-column key="marking_BAG" v-if="isLabelTypeBag" prop="marking" label="TYPE"></el-table-column>
        <el-table-column key="reserve_BAG" v-if="isLabelTypeBag" prop="reserve" label="NOTE"></el-table-column>
        <el-table-column key="packageType_BAG" v-if="isLabelTypeBag" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_MEMBRANE" v-if="isLabelTypeMembrane" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_MEMBRANE" v-if="isLabelTypeMembrane" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="customPartNo_MEMBRANE" v-if="isLabelTypeMembrane" prop="customPartNo" label="WFR NO"></el-table-column>
        <el-table-column key="qty_MEMBRANE" v-if="isLabelTypeMembrane" prop="qty" label="Die"></el-table-column>
        <el-table-column key="packageType_MEMBRANE" v-if="isLabelTypeMembrane" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_CASE" v-if="isLabelTypeCase" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_CASE" v-if="isLabelTypeCase" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_CASE" v-if="isLabelTypeCase" prop="qty" label="QTY"></el-table-column>
        <el-table-column key="dateCode_CASE" v-if="isLabelTypeCase" prop="dateCode" label="Date"></el-table-column>
        <el-table-column key="customPartNo_CASE" v-if="isLabelTypeCase" prop="customPartNo" label="WFR NO"></el-table-column>
        <el-table-column key="marking_CASE" v-if="isLabelTypeCase" prop="marking" label="TYPE"></el-table-column>
        <el-table-column key="reserve_CASE" v-if="isLabelTypeCase" prop="reserve" label="NOTE"></el-table-column>
        <el-table-column key="packageType_CASE" v-if="isLabelTypeCase" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="partNo_BAGC" v-if="isLabelTypeBagC" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_BAGC" v-if="isLabelTypeBagC" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_BAGC" v-if="isLabelTypeBagC" prop="qty" label="QTY"></el-table-column>
        <el-table-column key="dateCode_BAGC" v-if="isLabelTypeBagC" prop="dateCode" label="Date"></el-table-column>
        <el-table-column key="customPartNo_BAGC" v-if="isLabelTypeBagC" prop="customPartNo" label="WFR NO"></el-table-column>
        <el-table-column key="marking_BAGC" v-if="isLabelTypeBagC" prop="marking" label="TYPE"></el-table-column>
        <el-table-column key="reserve_BAGC" v-if="isLabelTypeBagC" prop="reserve" label="NOTE"></el-table-column>
        <el-table-column key="packageType_BAGC" v-if="isLabelTypeBagC" prop="packageType" label="档位"></el-table-column>

        <el-table-column key="reserve_MODULENO" v-if="isLabelTypeModuleNo" prop="reserve" label="模块编号"></el-table-column>
        <el-table-column key="packageType_MODULENO" v-if="isLabelTypeModuleNo" prop="packageType" label="二维码内容"></el-table-column>

        <el-table-column key="partNo_SXV2" v-if="isLabelTypeShiXinV2" prop="partNo" label="PARTNO"></el-table-column>
        <el-table-column key="lotNo_SXV2" v-if="isLabelTypeShiXinV2" prop="lotNo" label="印章号"></el-table-column>
        <el-table-column key="qty_SXV2" v-if="isLabelTypeShiXinV2" prop="qty" label="数量"></el-table-column>
        <el-table-column key="trackingNo_SXV2" v-if="isLabelTypeShiXinV2" prop="trackingNo" label="Tracking No"></el-table-column>
        <el-table-column key="binLevel_SXV2" v-if="isLabelTypeShiXinV2" prop="binLevel" label="档位"></el-table-column>
        <el-table-column key="dateCode_SXV2" v-if="isLabelTypeShiXinV2" prop="dateCode" label="发货日期"></el-table-column>
        <el-table-column key="packageType_SXV2" v-if="isLabelTypeShiXinV2" prop="packageType" label="封装形式"></el-table-column>
        <el-table-column key="marking_SXV2" v-if="isLabelTypeShiXinV2" prop="marking" label="Marking"></el-table-column>
        <el-table-column key="grossWeight_SXV2" v-if="isLabelTypeShiXinV2 && isBoxLabel" prop="grossWeight" label="毛重(kg)"></el-table-column>
        <el-table-column key="netWeight_SXV2" v-if="isLabelTypeShiXinV2 && isBoxLabel" prop="netWeight" label="净重(kg)"></el-table-column>
        <el-table-column key="reserve_SXV2" v-if="isLabelTypeShiXinV2" prop="reserve" label="类别"></el-table-column>
        <el-table-column key="customPartNo_SXV2" v-if="isLabelTypeShiXinV2" prop="customPartNo" label="标识"></el-table-column>

        <el-table-column key="partNo_HL" v-if="isLabelHuaLan" prop="partNo" label="P/N"></el-table-column>
        <el-table-column key="lotNo_HL" v-if="isLabelHuaLan" prop="lotNo" label="Lot No"></el-table-column>
        <el-table-column key="qty_HL" v-if="isLabelHuaLan" prop="qty" label="QTY"></el-table-column>
        <el-table-column key="waferNo_HL" v-if="isLabelHuaLan" prop="customPartNo" label="WFR NO"></el-table-column>
        <el-table-column key="note_HL" v-if="isLabelHuaLan" prop="reserve" label="NOTE"></el-table-column>
        <el-table-column key="prop_HL" v-if="isLabelHuaLan" prop="marking" label="Prop"></el-table-column>
        <el-table-column key="type_HL" v-if="isLabelHuaLan" prop="packageType" label="Type"></el-table-column>
        <el-table-column key="dateCode_HL" v-if="isLabelHuaLan" prop="dateCode" label="Date"></el-table-column>
        <el-table-column key="cn_HL" v-if="isLabelHuaLan" prop="purchaseOrderNo" label="C/N"></el-table-column>
        <el-table-column key="die_HL" v-if="isLabelHuaLan" prop="processingOrderNo" label="Die"></el-table-column>

        <el-table-column key="reserve_JT" v-if="isLabelJingTai" prop="reserve" label="供应商代码"></el-table-column>
        <el-table-column key="customPartNo_JT" v-if="isLabelJingTai" prop="customPartNo" label="物料代码"></el-table-column>
        <el-table-column key="partNo_JT" v-if="isLabelJingTai" prop="partNo" label="物料名称"></el-table-column>
        <el-table-column key="processingOrderNo_JT" v-if="isLabelJingTai" prop="processingOrderNo" label="规格型号"></el-table-column>
        <el-table-column key="qty_JT" v-if="isLabelJingTai" prop="qty" label="数量"></el-table-column>
        <el-table-column key="purchaseOrderNo_JT" v-if="isLabelJingTai" prop="purchaseOrderNo" label="订单号"></el-table-column>
        <el-table-column key="dateCode_JT" v-if="isLabelJingTai" prop="dateCode" label="生产日期"></el-table-column>

        <el-table-column label="更新时间" width="120">
          <template slot-scope="scope">
            {{formatDate(scope.row.updateAt)}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operate')" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="deleteClick(scope.row)">
              {{$t('common.delete')}}
            </el-button>
            <el-button type="text" class="link" @click="editClick(scope.row)">
              {{$t('common.edit')}}
            </el-button>
            <el-button type="text" class="link" @click="reprintClick(scope.row)">
              {{$t('common.reprint')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
  import moment from 'moment';
  import {
    boxListGet,
    deleteBox,
  } from '@/api/boxLabel';
  import {
    getLabel,
    deleteLabel,
  } from '@/api/label';
  import {
    remove_ie_header_and_footer,
  } from '@/utils';
  import {
    definedLabelType
  } from '@/utils/defines';
  import {
    generateBinLevelValue,
  } from '@/utils/label';
  import {
    initYuanHengLabelFrame,
    initQiangLiJuCaiLabelFrame,
    initQiangLiJuCaiLabelV2Frame,
    initLiYaDeLabelFrame,
    initBaKeLabelFrame,
    initLeiManLabelFrame,
    initMeiKaLeLabelFrame,
    initYiShiDaLabelFrame,
    initJianHeLabelFrame,
    initJinLiXiangLabelFrame,
    initShiXinLabelFrame,
    initQiangLiBoxLabelFrame,
    initLianJianLabelFrame,
    initWaferLabelFrame,
    initBoxLabelFrame,
    initWaferBoxLabelFrame,
    initBagLabelFrame,
    initMembraneLabelFrame,
    initCaseLabelFrame,
    initBagLabelCFrame,
    initModuleNoLabelFrame,
    initShiXinLabelV2Frame,
    initHuaLanLabelFrame,
    initJingTaiLabelFrame,
  } from '@/utils/factory-label';
  import YuanHengLabelDialog from './components/YuanHengLabelDialog';
  import QiangLiJuCaiLabelDialog from './components/QiangLiJuCaiLabelDialog';
  import QiangLiJuCaiLabelV2Dialog from './components/QiangLiJuCaiLabelV2Dialog';
  import LiYaDeLabelDialog from './components/LiYaDeLabelDialog';
  import YiShiDaLabelDialog from './components/YiShiDaLabelDialog';
  import commonLabelDialog from './components/commonLabelDialog';
  import JianHeLabelDialog from './components/JianHeLabelDialog';
  import JinLiXiangLabelDialog from './components/JinLiXiangLabelDialog';
  import ShiXinLabelDialog from './components/ShiXinLabelDialog';
  import QiangLiBoxLabelDialog from './components/QiangLiBoxLabelDialog';
  import LianJianLabelDialog from './components/LianJianLabelDialog';
  import BoxLabelDialog from './components/BoxLabelDialog';
  import WaferLabelDialog from './components/WaferLabelDialog';
  import WaferBoxLabelDialog from './components/WaferBoxLabelDialog';
  import BagLabelDialog from './components/BagLabelDialog';
  import MembraneLabelLabelDialog from './components/MembraneLabelLabelDialog';
  import CaseLabelDialog from './components/CaseLabelDialog';
  import BagLabelCDialog from './components/BagLabelCDialog';
  import ModuleNoLabelDialog from './components/ModuleNoLabelDialog';
  import ShiXinLabelV2Dialog from './components/ShiXinLabelV2Dialog';
  import HuaLanLabelDialog from './components/HuaLanLabelDialog';
  import JingTaiLabelDialog from './components/JingTaiLabelDialog';
  import {
    Pagination,
  } from '@/components';
  import {
    boxLabelTypes,
  } from '@/utils/defines'

  const LABEL_OF_CASE = 'LABEL_OF_CASE';
  const LABEL_OF_BOX = 'LABEL_OF_BOX';
  const defaultForm = {
    label: LABEL_OF_BOX,
    labelType: definedLabelType.yuanheng.val,
    keyword: undefined,
  };

  export default {
    name: "FactoryLabelHistory",
    components: {
      YuanHengLabelDialog,
      QiangLiJuCaiLabelDialog,
      QiangLiJuCaiLabelV2Dialog,
      LiYaDeLabelDialog,
      YiShiDaLabelDialog,
      BaKeLabelDialog: commonLabelDialog,
      LeiManLabelDialog: commonLabelDialog,
      MeiKaLeLabelDialog: commonLabelDialog,
      JianHeLabelDialog,
      JinLiXiangLabelDialog,
      ShiXinLabelDialog,
      Pagination,
      QiangLiBoxLabelDialog,
      LianJianLabelDialog,
      BoxLabelDialog,
      WaferLabelDialog,
      WaferBoxLabelDialog,
      BagLabelDialog,
      MembraneLabelLabelDialog,
      CaseLabelDialog,
      BagLabelCDialog,
      ModuleNoLabelDialog,
      ShiXinLabelV2Dialog,
      HuaLanLabelDialog,
      JingTaiLabelDialog,
    },
    data() {
      const labelList = [ {
        label: '箱标',
        value: LABEL_OF_BOX
      }, {
        label: '盘标',
        value: LABEL_OF_CASE
      }];
      const labelTypeList = [];
      for (let [key, value] of Object.entries(definedLabelType)) {
        if (value.val !== definedLabelType.shixin.val) {
          labelTypeList.push({
            label: value.chinese,
            value: value.val
          });
        }
      }
      return {
        form: {...defaultForm},
        searchParams: Object.assign({}, defaultForm),
        rules: {
        },
        labelList,
        listData: [],
        definedLabelType,
        loading: false,
        totalCount: 0,
        page: 1,
        perpage: 20,
        labelTypeList,
        labelType: definedLabelType.yuanheng.val,
        isBoxLabel: false,

        yuanHengLabelDialogVisible: false,
        qiangLiJuCaiLabelDialogVisible: false,
        qiangLiJuCaiLabelV2DialogVisible: false,
        liYaDeLabelDialogVisible: false,
        yiShiDaLabelDialogVisible: false,
        baKeLabelDialogVisible: false,
        leiManLabelDialogVisible: false,
        meiKaLeLabelDialogVisible: false,
        JianHeLabelDialogVisible: false,
        jinLiXiangLabelDialogVisible: false,
        shiXinLabelDialogDialogVisible: false,
        qiangLiBoxLabelDialogVisible: false,
        lianJianLabelDialogVisible: false,
        boxLabelDialogVisible: false,
        waferLabelDialogVisible: false,
        waferBoxLabelDialogVisible: false,
        bagLabelDialogVisible: false,
        membraneLabelDialogVisible: false,
        caseLabelDialogVisible: false,
        bagLabelCDialogVisible: false,
        moduleNoDialogVisible: false,
        shiXinLabelV2DialogVisible: false,
        huaLanLabelDialogVisible: false,
        jingTaiLabelDialogVisible: false,
        editRow: {},
      }
    },
    computed: {
      displayData() {
        return this.listData;
      },
      pageCount() {
        return Math.ceil(this.totalCount / this.perpage);
      },
      isLabelTypeYuanHeng() {
        return this.labelType === definedLabelType.yuanheng.val;
      },
      isLabelTypeQiangli() {
        return this.labelType === definedLabelType.qiangli.val;
      },
      isLabelTypeQiangliV2() {
        return this.labelType === definedLabelType.qiangli_v2.val;
      },
      isLabelTypeQiangliBox() {
        return this.labelType === definedLabelType.qiangli_box.val;
      },
      isLabelTypeLiYaDe() {
        return this.labelType === definedLabelType.liyade.val || this.labelType === definedLabelType.liyadedianshi.val;
      },
      isLabelTypeCommon() {
        const {
          labelType,
        } = this;
        return labelType === definedLabelType.bake.val || labelType === definedLabelType.leiman.val
          || labelType === definedLabelType.meikale.val;
      },
      isLabelTypeYiShiDa() {
        return this.labelType === definedLabelType.yishida.val;
      },
      isLabelTypeJianHe() {
        return this.labelType === definedLabelType.jianhe.val;
      },
      isLabelTypeJinLiXiang() {
        return this.labelType === definedLabelType.jinlixiang.val;
      },
      isLabelTypeShiXin() {
        return this.labelType === definedLabelType.shixin2.val;
      },
      isLabelTypeLianJian() {
        return this.labelType === definedLabelType.lianjian.val;
      },
      isLabelTypeJingYuanDai() {
        return this.labelType === definedLabelType.jingyuan_dai.val;
      },
      isLabelTypeJingYuanPian() {
        return this.labelType === definedLabelType.jingyuan_pian.val;
      },
      isLabelTypeJingYuanBox() {
        return this.labelType === definedLabelType.jingyuan_box.val;
      },
      isLabelTypeBag() {
        return this.labelType === definedLabelType.bag.val;
      },
      isLabelTypeMembrane() {
        return this.labelType === definedLabelType.membrane.val;
      },
      isLabelTypeCase() {
        return this.labelType === definedLabelType.case.val;
      },
      isLabelTypeBagC() {
        return this.labelType === definedLabelType.bagC.val;
      },
      isLabelTypeModuleNo() {
        return this.labelType === definedLabelType.moduleNo.val;
      },
      isLabelTypeShiXinV2() {
        return this.labelType === definedLabelType.shixinV2.val;
      },
      isLabelHuaLan() {
        return this.labelType === definedLabelType.hualan.val;
      },
      isLabelJingTai() {
        return this.labelType === definedLabelType.jingtai.val;
      },
      keywordVal() {
        const keywordTable = {
          [definedLabelType.yuanheng.val]: '规格型号或批次号',
          [definedLabelType.qiangli.val]: '品名/规格或强力批号',
          [definedLabelType.liyade.val]: 'LYD物料描述或生产批次',
          [definedLabelType.liyadedianshi.val]: 'LYD物料描述或生产批次',
          [definedLabelType.yishida.val]: '',
          [definedLabelType.bake.val]: 'PARTNO或印章号或trackingNo',
          [definedLabelType.leiman.val]: 'PARTNO或印章号或trackingNo',
          [definedLabelType.jianhe.val]: '物料名称',
          [definedLabelType.meikale.val]: 'PARTNO或印章号或trackingNo',
          [definedLabelType.jinlixiang.val]: '物料描述或生产批次',
          [definedLabelType.qiangli_v2.val]: '规格型号或强力批号',
          [definedLabelType.shixin2.val]: 'PARTNO或印章号或trackingNo',
          [definedLabelType.qiangli_box.val]: '箱号或规格型号或强力批号或外箱批号',
          [definedLabelType.lianjian.val]: '物料名称',
          [definedLabelType.jingyuan_dai.val]: 'Tracking No',
          [definedLabelType.jingyuan_pian.val]: '',
          [definedLabelType.jingyuan_box.val]: 'Tracking No',
        };
        if (!keywordTable[this.form.labelType]) {
          this.form.keyword = undefined;
        }
        return keywordTable[this.form.labelType];
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        const {
          label,
          labelType,
        } = vm.$route.query;
        if (label) {
          if (String(label) === String(boxLabelTypes.boxLabel.val)) {
            vm.form.label = LABEL_OF_BOX;
          } else {
            vm.form.label = LABEL_OF_CASE;
          }
        }
        if (labelType) {
          const findIndex = vm.labelTypeList.findIndex(item => item.value === Number.parseInt(labelType, 10));
          if (findIndex !== -1) {
            vm.form.labelType = Number.parseInt(labelType, 10);
          }
        }
        vm.query();
      })
    },
    methods: {
      reset() {
        this.page = 1;
        this.form = {...defaultForm};
        this.searchParams = Object.assign({}, defaultForm);
        this.getLabelData();
      },
      query() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.page = 1;
            this.searchParams = {...this.form};
            this.getLabelData();
          }
        });
      },
      getLabelData() {
        const {
          label,
        } = this.searchParams;
        if (label === LABEL_OF_CASE) {
          this.getLabel();
        } else if (label === LABEL_OF_BOX) {
          this.boxListGet();
        }
      },
      async boxListGet() {
        const {
          page,
          perpage,
        } = this;
        const {
          labelType,
          keyword,
        } = this.searchParams;
        try {
          this.loading = true;
          let param = {
            page,
            perpage,
            labelType: labelType || undefined,
            keyword: keyword || undefined,
          };
          const res = await boxListGet(param);
          this.loading = false;
          const data = res.data;
          if (data.count !== undefined) {
            this.totalCount = data.count;
          }
          this.listData = data.info;
          this.labelType = labelType;
          this.isBoxLabel = true;
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      async getLabel() {
        const {
          page,
          perpage,
        } = this;
        const {
          labelType,
          keyword,
        } = this.searchParams;
        this.loading = true;
        try {
          const res = await getLabel({
            page,
            perpage,
            labelType: labelType || undefined,
            keyword: keyword || undefined,
          });
          const data = res.data;
          if (data.count !== undefined) {
            this.totalCount = data.count;
          }
          this.listData = data.info;
          this.labelType = labelType;
          this.isBoxLabel = false;
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      onChangePage() {
        this.getLabelData();
      },
      deleteClick(row) {
        this.$confirm(this.$t('factoryLabelHistory.thisActionWillDeleteThisLabel'), this.$t('remindInfo.warning'), {
          confirmButtonText: this.$t('remindInfo.confirm'),
          cancelButtonText: this.$t('remindInfo.cancel'),
          type: 'warning',
        }).then(async () => {
          const {
            isBoxLabel,
          } = this;
          try {
            const {
              id
            } = row;
            if (isBoxLabel) {
              await deleteBox({
                boxLabelIds: [id],
              });
            } else {
              await deleteLabel({
                labelIds: [id],
              });
            }
            this.$message({
              type: 'success',
              message: this.$t('common.deleteSuccess'),
            });
            this.getLabelData();
          } catch (e) {
            // do nothing.
          }
        }).catch(() => {
          // do nothing.
        });
      },
      editClick(row) {
        const {
          labelType,
        } = row;
        this.editRow = row;
        switch (labelType) {
          case definedLabelType.yuanheng.val:
            this.yuanHengLabelDialogVisible = true;
            break;
          case definedLabelType.qiangli.val:
            this.qiangLiJuCaiLabelDialogVisible = true;
            break;
          case definedLabelType.qiangli_v2.val:
            this.qiangLiJuCaiLabelV2DialogVisible = true;
            break;
          case definedLabelType.liyade.val:
            this.liYaDeLabelDialogVisible = true;
            break;
          case definedLabelType.liyadedianshi.val:
            this.liYaDeLabelDialogVisible = true;
            break;
          case definedLabelType.yishida.val:
            this.yiShiDaLabelDialogVisible = true;
            break;
          case definedLabelType.bake.val:
            this.baKeLabelDialogVisible = true;
            break;
          case definedLabelType.leiman.val:
            this.leiManLabelDialogVisible = true;
            break;
          case definedLabelType.jianhe.val:
            this.JianHeLabelDialogVisible = true;
            break;
          case definedLabelType.meikale.val:
            this.meiKaLeLabelDialogVisible = true;
            break;
          case definedLabelType.jinlixiang.val:
            this.jinLiXiangLabelDialogVisible = true;
            break;
          case definedLabelType.shixin2.val:
            this.shiXinLabelDialogDialogVisible = true;
            break;
          case definedLabelType.qiangli_box.val:
            this.qiangLiBoxLabelDialogVisible = true;
            break;
          case definedLabelType.lianjian.val:
            this.lianJianLabelDialogVisible = true;
            break;
          case definedLabelType.jingyuan_dai.val:
            this.waferLabelDialogVisible = true;
            break;
          case definedLabelType.jingyuan_pian.val:
            this.boxLabelDialogVisible = true;
            break;
          case definedLabelType.jingyuan_box.val:
            this.waferBoxLabelDialogVisible = true;
            break;
          case definedLabelType.bag.val:
            this.bagLabelDialogVisible = true;
            break;
          case definedLabelType.membrane.val:
            this.membraneLabelDialogVisible = true;
            break;
          case definedLabelType.case.val:
            this.caseLabelDialogVisible = true;
            break;
          case definedLabelType.bagC.val:
            this.bagLabelCDialogVisible = true;
            break;
          case definedLabelType.moduleNo.val:
            this.moduleNoDialogVisible = true;
            break;
          case definedLabelType.shixinV2.val:
            this.shiXinLabelV2DialogVisible = true;
            break;
          case definedLabelType.hualan.val:
            this.huaLanLabelDialogVisible = true;
            break;
          case definedLabelType.jingtai.val:
            this.jingTaiLabelDialogVisible = true;
            break;        
          default:
            break;
        }
      },
      reprintClick(row) {
        const {
          labelType,
        } = row;
        let iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe = this.initLabel(iframe, labelType, row);
        setTimeout(() => {
          if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
            remove_ie_header_and_footer();
          }
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
          iframe = null;
        }, 200);
      },
      initLabel(iframe, labelType, val) {
        switch (labelType) {
          case definedLabelType.yuanheng.val:
            iframe = initYuanHengLabelFrame({
              iframe,
              processingOrderNo: val.processingOrderNo,
              purchaseOrderNo: val.purchaseOrderNo,
              materialNo: val.customPartNo,
              specificationNo: val.partNo,
              deliveryDate: val.dateCode,
              count: val.qty,
              boxNo: val.reserve,
            });
            break;
          case definedLabelType.qiangli.val:
            iframe = initQiangLiJuCaiLabelFrame({
              iframe,
              partNo: val.partNo,
              materialNo: val.customPartNo,
              orderNo: val.purchaseOrderNo,
              count: val.qty,
              weight: val.grossWeight,
              deliveryDate: val.dateCode,
              batchNo: val.trackingNo,
            });
            break;
          case definedLabelType.qiangli_v2.val:
            initQiangLiJuCaiLabelV2Frame({
              iframe,
              machineHandNo: val.processingOrderNo,
              partNo: val.partNo,
              materialNo: val.customPartNo,
              count: val.qty,
              deliveryDate: val.dateCode,
              trackingNo: val.trackingNo,
            });
            break;
          case definedLabelType.liyade.val:
            iframe = initLiYaDeLabelFrame({
              iframe,
              orderNo: val.purchaseOrderNo,
              materialNo: val.customPartNo,
              materialDescription: val.partNo,
              count: val.qty,
              deliveryDate: val.dateCode,
              productionBatch: val.lotNo,
            });
            break;
          case definedLabelType.liyadedianshi.val:
            iframe = initLiYaDeLabelFrame({
              iframe,
              orderNo: val.purchaseOrderNo,
              materialNo: val.customPartNo,
              materialDescription: val.partNo,
              count: val.qty,
              deliveryDate: val.dateCode,
              productionBatch: val.lotNo,
            });
            break;
          case definedLabelType.yishida.val:
            iframe = initYiShiDaLabelFrame({
              iframe,
              orderNo: val.purchaseOrderNo,
              customerMaterialNo: val.customPartNo,
              count: val.qty,
            });
            break;
          case definedLabelType.bake.val:
            iframe = initBaKeLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              trackingNo: val.trackingNo,
              dateCode: val.dateCode,
              packageType: val.packageType,
              result: val.result,
              marking: val.marking,
              grossWeight: val.grossWeight,
              netWeight: val.netWeight,
              binLevelExplain: val.reserve === null ? 'A' : val.reserve,
              customerMaterialNo: val.customPartNo,
            });
            break;
          case definedLabelType.leiman.val:
            iframe = initLeiManLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              trackingNo: val.trackingNo,
              dateCode: val.dateCode,
              packageType: val.packageType,
              result: val.result,
              marking: val.marking,
              grossWeight: val.grossWeight,
              netWeight: val.netWeight,
              binLevelExplain: val.reserve === null ? 'A' : val.reserve,
              customerMaterialNo: val.customPartNo,
            });
            break;
          case definedLabelType.jianhe.val:
            iframe = initJianHeLabelFrame({
              iframe,
              materialNo: val.customPartNo,
              materialName: val.partNo,
              contractNo: val.purchaseOrderNo,
              deliveryDate: val.dateCode,
            });
            break;
          case definedLabelType.meikale.val:
            iframe = initMeiKaLeLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              trackingNo: val.trackingNo,
              dateCode: val.dateCode,
              packageType: val.packageType,
              result: val.result,
              marking: val.marking,
              grossWeight: val.grossWeight,
              netWeight: val.netWeight,
              binLevelExplain: val.reserve === null ? 'A' : val.reserve,
              customerMaterialNo: val.customPartNo,
            });
            break;
          case definedLabelType.jinlixiang.val:
            iframe = initJinLiXiangLabelFrame({
              iframe,
              orderNo: val.purchaseOrderNo,
              materialNo: val.customPartNo,
              materialDescription: val.partNo,
              count: val.qty,
              deliveryDate: val.dateCode,
              productionBatch: val.lotNo,
            });
            break;
          case definedLabelType.shixin2.val:
            const {
              partNo,
              chipName,
              binLevel,
            } = val;
            let binLevelValue = generateBinLevelValue({partNo, chipName, binLevel});
            iframe = initShiXinLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              trackingNo: val.trackingNo,
              dateCode: val.dateCode,
              packageType: val.packageType,
              result: val.result,
              marking: val.marking,
              grossWeight: val.grossWeight,
              netWeight: val.netWeight,
              binLevelExplain: binLevelValue,
            });
            break;
          case definedLabelType.qiangli_box.val:
            if (val.reserve) {
              try {
                let reserve = JSON.parse(val.reserve);
                let info = reserve.info;
                let reserveInfo = [];
                let i = 0;
                let lotNoIndex = 0;
                for (let v of info) {
                  i++;
                  reserveInfo.push(v);
                  if (i % 4 === 0) {
                    lotNoIndex++;
                    iframe = initQiangLiBoxLabelFrame({
                      iframe,
                      partNo: val.partNo,
                      lotNo: val.lotNo,
                      trackingNo: val.trackingNo,
                      reserveInfo: reserveInfo,
                      index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
                      lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : '',
                    });
                    reserveInfo = [];
                  }
                }
                if (reserveInfo.length > 0) {
                  lotNoIndex++;
                  iframe = initQiangLiBoxLabelFrame({
                    iframe,
                    partNo: val.partNo,
                    lotNo: val.lotNo,
                    trackingNo: val.trackingNo,
                    reserveInfo: reserveInfo,
                    index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
                    lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : '',
                  });
                }
              } catch (e) {
                // do nothing.
              }
            }
            break;
          case definedLabelType.lianjian.val:
            iframe = initLianJianLabelFrame({
              iframe,
              materialNo: val.customPartNo,
              materialName: val.partNo,
              contractNo: val.purchaseOrderNo,
              deliveryDate: val.dateCode,
            });
            break;
          case definedLabelType.jingyuan_dai.val:
            iframe = initWaferLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              waferCount: val.qty,
              waferNo: val.customPartNo,
              prop: val.marking,
              dateCode: val.dateCode,
              qty: val.reserve,
              trackingNo: val.trackingNo,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.jingyuan_pian.val:
            iframe = initBoxLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              waferNo: val.marking,
              qty: val.reserve,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.jingyuan_box.val:
            iframe = initWaferBoxLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              waferCount: val.qty,
              dateCode: val.dateCode,
              qty: val.reserve,
              trackingNo: val.trackingNo,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.bag.val:
            iframe = initBagLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              waferNo: val.customPartNo,
              type: val.marking,
              note: val.reserve,
              dateCode: val.dateCode,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.membrane.val:
            iframe = initMembraneLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              waferNo: val.customPartNo,
              qty: val.qty,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.case.val:
            iframe = initCaseLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              waferNo: val.customPartNo,
              type: val.marking,
              note: val.reserve,
              dateCode: val.dateCode,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.bagC.val:
            iframe = initBagLabelCFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              waferNo: val.customPartNo,
              type: val.marking,
              note: val.reserve,
              dateCode: val.dateCode,
              binLevelExplain: val.packageType,
            });
            break;
          case definedLabelType.moduleNo.val:
            iframe = initModuleNoLabelFrame({
              iframe,
              moduleNo: val.reserve,
              moduleNoQrCode: val.packageType,
            });
            break;
          case definedLabelType.shixinV2.val:
            let binLevelValueV2 = generateBinLevelValue({
              partNo: val.partNo, 
              chipName: val.chipName,
              binLevel: val.binLevel,
            });
            iframe = initShiXinLabelV2Frame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              trackingNo: val.trackingNo,
              dateCode: val.dateCode,
              packageType: val.packageType,
              result: val.reserve,
              marking: val.marking,
              grossWeight: val.grossWeight,
              netWeight: val.netWeight,
              binLevelExplain: binLevelValueV2,
              result: val.reserve,
              remark: val.customPartNo,
            });
            break;
          case definedLabelType.hualan.val:
            iframe = initHuaLanLabelFrame({
              iframe,
              partNo: val.partNo,
              lotNo: val.lotNo,
              qty: val.qty,
              waferNo: val.customPartNo,
              note: val.reserve,
              prop: val.marking,
              type: val.packageType,
              dateCode: val.dateCode,
              cn: val.purchaseOrderNo,
              die: val.processingOrderNo,
            });
            break;
          case definedLabelType.jingtai.val:
            iframe = initJingTaiLabelFrame({
              iframe,
              supplierCode: val.reserve,
              materialCode: val.customPartNo,
              materialName: val.partNo,
              specModel: val.processingOrderNo,
              qty: val.qty,
              orderNo: val.purchaseOrderNo,
              dateCode: val.dateCode,
            });
            break;  
          default:
            break;
        }
        return iframe;
      },
      formatDate(updateAt) {
        let updateDate = moment.utc(updateAt);
        let isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
        if (isSameYear) {
          return updateDate.local().format("MM/DD HH:mm");
        } else {
          return updateDate.local().format("YYYY/MM/DD HH:mm");
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }

  .el-form {
    padding: 10px 20px 0;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }

  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }

  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 20px;
    height: 100%;
    overflow: auto;
  }

  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }

  .link {
    color: #169BD5;
    padding: 0 5px;
  }

  .link.is-disabled {
    color: #C0C4CC;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }

  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
